import request from '../../../shared/request'

export function getPaymentRequests(jobId) {
  return request(`/job/payment_requests/${jobId}/`)
}

export function getPaymentRequestsDashboard(assignedToId) {
  return request(`/dashboard/payment-requests/${assignedToId}/`)
}

export function getPaymentRequestsByVendorId(vendorId) {
  return request(`/job/payment_requests/${vendorId}/vendor`)
}

export function createPaymentRequest(payload) {
  return request(`/job/payment_requests/`, {
    method: 'POST',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function updatePaymentRequest(payload) {
  return request(`/job/payment_requests/${payload.payment_request_id}/`, {
    method: 'PUT',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function deletePaymentRequest(payload) {
  return request(`/job/payment_requests/${payload.payment_request_id}/`, {
    method: 'DELETE',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function uploadAttachments(payload) {
  return request(`/job/payment_requests/${payload.paymentRequestId}/attachment`, {
    method: 'POST',
    body: payload.formData,
    headers: {
      'content-type': 'multipart/form-data'
    }
  })
}

export function getAttachments(paymentRequestId) {
  return request(`/job/payment_requests/${paymentRequestId}/attachments/`)
}

export function updateAttachmentDescription(payload) {
  return request(`/job/payment_requests/${payload.attachmentId}/attachment`, {
    method: 'PUT',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function deleteAttachment(payload) {
  return request(`/job/payment_requests/${payload.attachmentId}/attachment/`, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

// notes
export function fetchPaymentRequestNote(payload) {
  return request(`/job/payment_requests/${payload.paymentRequestId}/notes`)
}

export function createPaymentRequestNote(payload) {
  return request(`/job/payment_requests/${payload.paymentRequestId}/notes`, {
    method: 'POST',
    body: payload,
    headers: {
      'content-type': 'multipart/form-data'
    }
  })
}

export function editPaymentRequestNote(payload) {
  return request(`/job/payment_requests/${payload.noteId}/notes`, {
    method: 'PUT',
    body: payload,
    headers: {
      'content-type': 'multipart/form-data'
    }
  })
}

export function deletePaymentRequestNote(payload) {
  return request(`/job/payment_requests/${payload.noteId}/notes`, {
    method: 'DELETE',
    headers: {
      'content-type': 'multipart/form-data'
    }
  })
}



// WEBPACK FOOTER //
// ./src/redux/api/job/paymentRequests.js